import React from 'react';

import AdminRoute from '../../shared/routes/AdminRoute';
import AdminLayout from '../../layouts/Admin.layout';
import { ADMIN_STATISTICS_APP_PATHS } from '../../shared/statistics/constants/path.constants';
import AdminStatisticsCommissionPage from '../../views/admin/statistics/commission/Page';
import AdminStatisticsSalesPage from '../../views/admin/statistics/sales/Page';
import { Route } from '../../shared/types/routes.type';

const ADMIN_STATISTICS_ROUTES: Route[] = [
  {
    exact: true,
    path: ADMIN_STATISTICS_APP_PATHS.COMMISSIONS,
    layout: AdminLayout,
    component: AdminStatisticsCommissionPage,
  },
  {
    exact: true,
    path: ADMIN_STATISTICS_APP_PATHS.SALES,
    layout: AdminLayout,
    component: AdminStatisticsSalesPage,
  },
];

export default function AdminStatisticsRoutes(): JSX.Element {
  return (
    <React.Fragment>
      {ADMIN_STATISTICS_ROUTES.map((route) => (
        <AdminRoute key={route.path} {...route} />
      ))}
    </React.Fragment>
  );
}
